<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Admin Locks/Sessões - Sicronização ativa: {{ statusSinc }}</h5>
                <hr>
				<TabView>					
                    <TabPanel header="Locks" class="p-mt-3">

						<Toolbar class="p-mb-4">
							<template slot="left">						
								<Button icon="pi pi-clock" label="Auto Refresh Ligado" class="p-mr-3" @click="pararAutoRefresh" v-if="autoRefreshOn"/>   
								<Button icon="pi pi-times-circle" label="Auto Refresh Parado" class="p-button-secondary p-mr-3" @click="ligarAutoRefresh" v-else/>
								<Dropdown v-model.number="tempoAutoRefresh" :options="intervalos" class="p-mr-3" 
									optionLabel="nome" optionValue="valor"/> 
								<Button :label="atualizacao" class="p-button-success p-mr-5" v-if="atualizacao"/>   
								<Button icon="pi pi-unlock" label="Liberar Total" class="p-mr-3" @click="removerLocksTotal(true)"/>   
								<Button icon="pi pi-lock" label="Controlar Total" @click="removerLocksTotal(false)"/>                    									
							</template>					
						</Toolbar>

						<DataTable :value="locks" :filters="filtro" class="p-datatable-sm p-datatable-striped">
							<template #header>
								<div class="table-header">			
									<div class="p-d-flex p-jc-end">				
										<span class="p-input-icon-left">
											<i class="pi pi-search" />
											<InputText v-model="filtro['global']" placeholder="Filtrar..." />
										</span>
									</div>
								</div>
							</template>
							<Column field="cliente" header="Cliente"></Column>
							<Column field="cnpj" header="Cnpj"></Column>
							<Column field="id" header="Id Lock"></Column>
							<Column field="tag" header="Tag"></Column>
							<Column field="data" header="Data"></Column>	
							<Column field="periodo" header="Período"></Column>							
							<Column>
								<template #body="slotProps">									
									<Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger" @click="removerLock(slotProps.data)"/>
								</template>
							</Column>
						</DataTable>
						</TabPanel>
						<TabPanel header="Sessões" class="p-mt-3">
						<Toolbar class="p-mb-4">
							<template slot="left">						
								<Button icon="pi pi-refresh" label="Atualizar" class="p-mr-3" @click="listarSessoes"/>   								                     									
							</template>					
						</Toolbar>

						<DataTable :value="sessoes" :filters="filtro" class="p-datatable-sm p-datatable-striped">
							<template #header>
								<div class="table-header">			
									<div class="p-d-flex p-jc-end">				
										<span class="p-input-icon-left">
											<i class="pi pi-search" />
											<InputText v-model="filtro['global']" placeholder="Filtrar..." />
										</span>
									</div>
								</div>
							</template>
							<Column field="id" header="Id Usuário"></Column>
							<Column field="idCliente" header="Código Cliente"></Column>							
							<Column field="data" header="Data"></Column>
						</DataTable>

					</TabPanel>
				</TabView>			

			</div>
		</div>
	</div>
</template>

<script>
import LockProcessoService from '@/service/LockProcessoService.js';
import { exibirMensagemSis } from '@/global';

export default {
	usuarioService: null,
    lockProcessoService: null,
	data() {
		return {	
			locks: [],
            autoRefreshOn: false,          
            tempoAutoRefresh: 1000,
            idTimeoutAutoRefresh: null,
            atualizacao: null,
			filtro: {},		
			sessoes: [],
			statusSinc: '?',
			intervalos: [{nome: '1s', valor: 1000}, {nome: '2s', valor: 2000}, {nome: '5s', valor: 5000}]
		}
	},
	methods: {	
        pararAutoRefresh() {
            clearTimeout(this.idTimeoutAutoRefresh);            
            this.autoRefreshOn = false;
        },
        ligarAutoRefresh() {
            clearTimeout(this.idTimeoutAutoRefresh);
            this.idTimeoutAutoRefresh = setTimeout(() => { this.listarLocks() }, this.tempoAutoRefresh);
            this.autoRefreshOn = true;
        },
		listarLocks(){
			this.lockProcessoService.listar()
            .then(resp => {		
                this.atualizacao = 'Atualização '+(new Date().toLocaleDateString()+' '+new Date().toLocaleTimeString());     
                let itens = [];
				this.statusSinc = resp.data.entity.statusSinc ? 'Sim' : 'Não';
				resp.data.entity.clientes.forEach(cli => {	
					if(cli.cnpjs) {
						cli.cnpjs.forEach(cnpj => {			
							if(cnpj.locks) {
									cnpj.locks.forEach(lock => {
									let item = {cliente: cli.cliente, cnpj: cnpj.cnpj};
									item['id'] = lock.id;
									item['tag'] = lock.tag.replaceAll('_', ' ');
									item['data'] = lock.data;
									item['periodo'] = lock.dataInicioPeriodo+' - '+lock.dataFimPeriodo;
									item['lock'] = lock;
									itens.push(item);
								})
							}	
						});
					}			
					
				});
				this.locks = itens;
                this.idTimeoutAutoRefresh = setTimeout(() => { this.listarLocks() }, this.tempoAutoRefresh); 
            }).catch(erro => {
                this.autoRefreshOn = false;
                if(erro.response && erro.response.data.status == 401) {
                    exibirMensagemSis(this, erro.response.data.message, true);
                } else {
                    exibirMensagemSis(this, 'Erro interno do servidor', true);
                    console.log(erro.request)
                } 
            });  
        },    
		removerLock(item) {
			this.lockProcessoService.liberar(item.lock)
            .then(resp => {			
                exibirMensagemSis(this, resp.data.entity.mensagem, false);
            }).catch(erro => {                
                if(erro.response && erro.response.data.status == 401) {
                    exibirMensagemSis(this, erro.response.data.message, true);
                } else {
                    exibirMensagemSis(this, 'Erro interno do servidor', true);
                    console.log(erro.request)
                } 
            }); 
		},
		removerLocksTotal(liberarTotal) {
			this.lockProcessoService.liberarTotal({liberarTotal: liberarTotal})
            .then(resp => {			
                exibirMensagemSis(this, resp.data.entity.mensagem, false);
            }).catch(erro => {                
                if(erro.response && erro.response.data.status == 401) {
                    exibirMensagemSis(this, erro.response.data.message, true);
                } else {
                    exibirMensagemSis(this, 'Erro interno do servidor', true);
                    console.log(erro.request)
                } 
            }); 
		},
		listarSessoes(){
			this.lockProcessoService.listarSesoes()
            .then(resp => {			
                this.sessoes = resp.data.entity;
            }).catch(erro => {                
                if(erro.response && erro.response.data.status == 401) {
                    exibirMensagemSis(this, erro.response.data.message, true);
                } else {
                    exibirMensagemSis(this, 'Erro interno do servidor', true);
                    console.log(erro.request)
                } 
            });  
        },     		
	},	
	created() {
        this.lockProcessoService = new LockProcessoService();	
	},	
}
</script>

<style scoped>
</style>